export default "__VITE_ASSET__Bgbgq94n__"